import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <img src="./logo.svg" alt="SAWWA" className="logo" />
    </header>
  );
};

export default Header;